import { Slide } from "packages/lesson/dist/@types";
import theory from "../../theory";

import m0_n0_p0 from "./components/m0-n0-p0";
import m0_n0_p1 from "./components/m0-n0-p1";
import m0_n0_p2 from "./components/m0-n0-p2";
import m0_n0_p3 from "./components/m0-n0-p3";
import m0_n0_p4 from "./components/m0-n0-p4";
import m0_n0_p5 from "./components/m0-n0-p5";
import m0_n1_p0 from "./components/m0-n1-p0";
import m0_n1_p1 from "./components/m0-n1-p1";
import m0_n1_p2 from "./components/m0-n1-p2";
import m0_n1_p3 from "./components/m0-n1-p3";
import m0_n1_p4 from "./components/m0-n1-p4";
import m0_n1_p5 from "./components/m0-n1-p5";
import m0_n2_p0 from "./components/m0-n2-p0";
import m0_n2_p1 from "./components/m0-n2-p1";
import m0_n2_p3 from "./components/m0-n2-p3";
import m0_n2_p2 from "./components/m0-n2-p2";
import m0_n2_p4 from "./components/m0-n2-p4";
import m0_n2_p5 from "./components/m0-n2-p5";
import m1_n0_p0 from "./components/m1-n0-p0";
import m1_n0_p1 from "./components/m1-n0-p1";
import m1_n0_p2 from "./components/m1-n0-p2";
import m1_n0_p3 from "./components/m1-n0-p3";
import m1_n0_p4 from "./components/m1-n0-p4";
import m1_n0_p5 from "./components/m1-n0-p5";
import m1_n1_p0 from "./components/m1-n1-p0";
import m1_n1_p2 from "./components/m1-n1-p2";
import m1_n1_p1 from "./components/m1-n1-p1";
import m1_n1_p3 from "./components/m1-n1-p3";
import m1_n1_p4 from "./components/m1-n1-p4";
import m1_n1_p5 from "./components/m1-n1-p5";
import m1_n2_p1 from "./components/m1-n2-p1";
import m1_n2_p0 from "./components/m1-n2-p0";
import m1_n2_p2 from "./components/m1-n2-p2";
import m1_n2_p3 from "./components/m1-n2-p3";
import m1_n2_p4 from "./components/m1-n2-p4";
import m1_n2_p5 from "./components/m1-n2-p5";
import m2_n0_p0 from "./components/m2-n0-p0";
import m2_n0_p1 from "./components/m2-n0-p1";
import m2_n0_p2 from "./components/m2-n0-p2";
import m2_n0_p3 from "./components/m2-n0-p3";
import m2_n0_p4 from "./components/m2-n0-p4";
import m2_n0_p5 from "./components/m2-n0-p5";
import m2_n1_p0 from "./components/m2-n1-p0";
import m2_n1_p1 from "./components/m2-n1-p1";
import m2_n1_p2 from "./components/m2-n1-p2";
import m2_n1_p3 from "./components/m2-n1-p3";
import m2_n1_p4 from "./components/m2-n1-p4";
import m2_n1_p5 from "./components/m2-n1-p5";
import m2_n2_p0 from "./components/m2-n2-p0";
import m2_n2_p1 from "./components/m2-n2-p1";
import m2_n2_p2 from "./components/m2-n2-p2";
import m2_n2_p3 from "./components/m2-n2-p3";
import m2_n2_p4 from "./components/m2-n2-p4";
import m2_n2_p5 from "./components/m2-n2-p5";

const principle: Slide = {
  description:
    "Consider the three cavities with analytical solutions for the eigenmodes: parallelepipedic (23 cm x 19 cm x 35 cm),  cylindrical (R = 10 cm, H = 20 cm) and spherical cavities (R = 10 cm). When the cavity presents symmetries (it is the case here for cylindrical and spherical cavities), some modes have the same natural frequency and are said to be degenerate. Each proper mode is associated to three indices (m, n, p) related to the three dimensions (x,y,z), (θ,r,z) or (φ,θ,r) for the parallelepipedic, cylindrical or spherical cavity, respectively. For each mode and cavity type, look at the pressure distribution and the degeneracies.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>PARALLELEPIPEDIC CAVITIES</b>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    justifyContent: "center",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controlsPosition: "bottom",
                controls: [
                  {
                    type: "dropdown",
                    options: {
                      label: "Index m (nodes along x)",
                    },
                    items: [{ name: "0" }, { name: "1" }, { name: "2" }],
                  },
                  {
                    type: "dropdown",
                    options: {
                      label: "Index n (nodes along y)",
                    },
                    items: [{ name: "0" }, { name: "1" }, { name: "2" }],
                  },
                  {
                    type: "dropdown",
                    options: {
                      label: "Index p (nodes along z)",
                    },
                    items: [{ name: "0" }, { name: "1" }, { name: "2" }, { name: "3" }, { name: "4" }],
                  },
                ],
                extraContent: [
                  [[], [], []],
                  [[], [], []],
                  [[], [], []],
                ],
                components: [
                  [
                    [m0_n0_p0, m0_n0_p1, m0_n0_p2, m0_n0_p3, m0_n0_p4, m0_n0_p5],
                    [m0_n1_p0, m0_n1_p1, m0_n1_p2, m0_n1_p3, m0_n1_p4, m0_n1_p5],
                    [m0_n2_p0, m0_n2_p1, m0_n2_p2, m0_n2_p3, m0_n2_p4, m0_n2_p5],
                  ],
                  [
                    [m1_n0_p0, m1_n0_p1, m1_n0_p2, m1_n0_p3, m1_n0_p4, m1_n0_p5],
                    [m1_n1_p0, m1_n1_p1, m1_n1_p2, m1_n1_p3, m1_n1_p4, m1_n1_p5],
                    [m1_n2_p0, m1_n2_p1, m1_n2_p2, m1_n2_p3, m1_n2_p4, m1_n2_p5],
                  ],
                  [
                    [m2_n0_p0, m2_n0_p1, m2_n0_p2, m2_n0_p3, m2_n0_p4, m2_n0_p5],
                    [m2_n1_p0, m2_n1_p1, m2_n1_p2, m2_n1_p3, m2_n1_p4, m2_n1_p5],
                    [m2_n2_p0, m2_n2_p1, m2_n2_p2, m2_n2_p3, m2_n2_p4, m2_n2_p5],
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
